import { dual, pipe } from '../../Function/dist/effect-Function.esm.js';
import { has as has$1, empty as empty$1, add as add$1 } from '../../HashSet/dist/effect-HashSet.esm.js';
import { flatMap, map } from './core.esm.js';
import { set, fromIterable as fromIterable$1, has as has$2, isEmpty as isEmpty$1, reduceWithIndex, reduceWithIndexSTM, remove as remove$1, removeAll as removeAll$1, removeIf as removeIf$1, removeIfDiscard as removeIfDiscard$1, retainIf as retainIf$1, retainIfDiscard as retainIfDiscard$1, takeFirst as takeFirst$1, takeFirstSTM as takeFirstSTM$1, takeSome as takeSome$1, takeSomeSTM as takeSomeSTM$1, keys, transform as transform$1, transformSTM as transformSTM$1 } from './tMap.esm.js';
import { map as map$1 } from '../../ReadonlyArray/dist/effect-ReadonlyArray.esm.js';

/** @internal */
const TSetSymbolKey = "effect/TSet";

/** @internal */
const TSetTypeId = /*#__PURE__*/Symbol.for(TSetSymbolKey);

/** @internal */
const tSetVariance = {
  _A: _ => _
};

/** @internal */
class TSetImpl {
  [TSetTypeId] = tSetVariance;
  constructor(tMap) {
    this.tMap = tMap;
  }
}

/** @internal */
const add = /*#__PURE__*/dual(2, (self, value) => set(self.tMap, value, void 0));

/** @internal */
const difference = /*#__PURE__*/dual(2, (self, other) => flatMap(toHashSet(other), values => removeIfDiscard(self, value => has$1(values, value))));

/** @internal */
const empty = () => fromIterable([]);

/** @internal */
const forEach = /*#__PURE__*/dual(2, (self, f) => reduceSTM(self, void 0, (_, value) => f(value)));

/** @internal */
const fromIterable = iterable => map(fromIterable$1(Array.from(iterable).map(a => [a, void 0])), tMap => new TSetImpl(tMap));

/** @internal */
const has = /*#__PURE__*/dual(2, (self, value) => has$2(self.tMap, value));

/** @internal */
const intersection = /*#__PURE__*/dual(2, (self, other) => flatMap(toHashSet(other), values => pipe(self, retainIfDiscard(value => pipe(values, has$1(value))))));

/** @internal */
const isEmpty = self => isEmpty$1(self.tMap);

/** @internal */
const make = (...elements) => fromIterable(elements);

/** @internal */
const reduce = /*#__PURE__*/dual(3, (self, zero, f) => reduceWithIndex(self.tMap, zero, (acc, _, key) => f(acc, key)));

/** @internal */
const reduceSTM = /*#__PURE__*/dual(3, (self, zero, f) => reduceWithIndexSTM(self.tMap, zero, (acc, _, key) => f(acc, key)));

/** @internal */
const remove = /*#__PURE__*/dual(2, (self, value) => remove$1(self.tMap, value));

/** @internal */
const removeAll = /*#__PURE__*/dual(2, (self, iterable) => removeAll$1(self.tMap, iterable));

/** @internal */
const removeIf = /*#__PURE__*/dual(2, (self, predicate) => pipe(removeIf$1(self.tMap, key => predicate(key)), map(map$1(entry => entry[0]))));

/** @internal */
const removeIfDiscard = /*#__PURE__*/dual(2, (self, predicate) => removeIfDiscard$1(self.tMap, key => predicate(key)));

/** @internal */
const retainIf = /*#__PURE__*/dual(2, (self, predicate) => pipe(retainIf$1(self.tMap, key => predicate(key)), map(map$1(entry => entry[0]))));

/** @internal */
const retainIfDiscard = /*#__PURE__*/dual(2, (self, predicate) => retainIfDiscard$1(self.tMap, key => predicate(key)));

/** @internal */
const size = self => map(toChunk(self), chunk => chunk.length);

/** @internal */
const takeFirst = /*#__PURE__*/dual(2, (self, pf) => takeFirst$1(self.tMap, key => pf(key)));

/** @internal */
const takeFirstSTM = /*#__PURE__*/dual(2, (self, pf) => takeFirstSTM$1(self.tMap, key => pf(key)));

/** @internal */
const takeSome = /*#__PURE__*/dual(2, (self, pf) => takeSome$1(self.tMap, key => pf(key)));

/** @internal */
const takeSomeSTM = /*#__PURE__*/dual(2, (self, pf) => takeSomeSTM$1(self.tMap, key => pf(key)));

/** @internal */
const toChunk = self => keys(self.tMap);

/** @internal */
const toHashSet = self => reduce(self, empty$1(), (acc, value) => pipe(acc, add$1(value)));

/** @internal */
const toReadonlyArray = self => reduce(self, [], (acc, value) => [...acc, value]);

/** @internal */
const toReadonlySet = self => map(toReadonlyArray(self), values => new Set(values));

/** @internal */
const transform = /*#__PURE__*/dual(2, (self, f) => transform$1(self.tMap, (key, value) => [f(key), value]));

/** @internal */
const transformSTM = /*#__PURE__*/dual(2, (self, f) => transformSTM$1(self.tMap, (key, value) => map(f(key), a => [a, value])));

/** @internal */
const union = /*#__PURE__*/dual(2, (self, other) => forEach(other, value => add(self, value)));

export { TSetTypeId, add, difference, empty, forEach, fromIterable, has, intersection, isEmpty, make, reduce, reduceSTM, remove, removeAll, removeIf, removeIfDiscard, retainIf, retainIfDiscard, size, takeFirst, takeFirstSTM, takeSome, takeSomeSTM, toChunk, toHashSet, toReadonlyArray, toReadonlySet, transform, transformSTM, union };
